export const environment = {
    production: false,
    BASE_URL: 'https://insp-img-label-api-dev.autotechiq.com/api'
};